<template>
    <template v-if="highlightName">
        <template v-if="location == 'list'">
            <template v-if="linkUrl != null">
                <router-link class="shop-list-row-ribbon" :to="linkUrl">
                    <ToolTip :content="`${tooltipContent}`">
                        <div class="ribbon2">
                            <span :style="`
                                border-color: ${highlightHexCode}; 
                                background: ${highlightHexCode}; 
                                background: linear-gradient(${highlightHexCode} 0%, ${highlightHexCode} 100%);
                            `">
                                {{ highlightName }}
                            </span>
                        </div>
                    </ToolTip>
                </router-link>
            </template>
            <template v-else>
                <div class="shop-list-row-ribbon">
                    <ToolTip :content="`${tooltipContent}`">
                        <div class="ribbon2">
                            <span :style="`
                                border-color: ${highlightHexCode}; 
                                background: ${highlightHexCode}; 
                                background: linear-gradient(${highlightHexCode} 0%, ${highlightHexCode} 100%);
                            `">
                                {{ highlightName }}
                            </span>
                        </div>
                    </ToolTip>
                </div>
            </template>
        </template>
        <template v-else-if="location == 'card'">
            <ToolTip :content="`${tooltipContent}`" className="product-ribbon-tooltip-card">
                <div class="ribbon">
                    <span :style="`
                        border-color: ${highlightHexCode}; 
                        background: ${highlightHexCode}; 
                        background: linear-gradient(${highlightHexCode} 0%, ${highlightHexCode} 100%);
                    `">
                        {{highlightName }}
                    </span>
                </div>
            </ToolTip>
        </template>
    </template>
</template>
<script setup>
import { computed } from 'vue';
import ToolTip from './ToolTip.vue';

const props = defineProps({
    product: {
        type: Object,
        required: true
    },
    deliveryDate: {
        type: String,
        required: false,
        default: ''
    },
    location: {
        type: String,
        required: true,
        validator: (value) => ['list', 'card'].includes(value)
    }
});

const excludedPdpLinkProgramCodes = [
    'dbl', 
    'dbl2', 
    'mmt',
    'sbl'
];

const highlightName = computed(() => {
    if (props.product.highlight_name) {
        return props.product.highlight_name;
    }

    if (props.product.display_ribbon) {
        return props.product.ribbon_name;
    }

    return null;
});

const tooltipContent = computed(() => {
    let content = null;
    if (highlightName.value) {
        content = highlightName.value;
    }

    if (props.product.highlight_description) {
        content += ` - ${props.product.highlight_description}`;
    }
    return content;
});

const highlightHexCode = computed(() => {
    if (props.product.highlight_hex_code) {
        return props.product.highlight_hex_code;
    }
    return '#f48062';
});

const linkUrl = computed(() => {
    let programCode = props.product.program_code || props.product.programtype || '';
    programCode = programCode.toLowerCase();
    if (!excludedPdpLinkProgramCodes.includes(programCode) && props.deliveryDate != '') {
        return `/${props.product.slug}?date=${props.deliveryDate}`;
    }

    return null;
});
</script>
<style scoped>
.shop-list-row-ribbon {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: auto;
  margin: 0;
  padding: 0;
}
.ribbon, .ribbon-flower-library, .ribbon-special {
    position: absolute;
    top: -7px;
    left: -8px;
    z-index: 1;
    overflow: hidden;
    width: 86px;
    height: 76px;
    text-align: right;
}
.ribbon span, .ribbon-flower-library span, .ribbon-special span {
    font-size: 10px;
    font-weight: bold;
    color: #FFF;
    text-transform: uppercase;
    text-align: center;
    line-height: 20px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    width: 100px;
    display: block;
    background: #f48062;
    background: linear-gradient(#f48062 0%, #f48062 100%);
    box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
    position: absolute;
    top: 20px;
    right: 4px;}
.ribbon span::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid;
    border-left-color: inherit;
    border-right: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-top: 3px solid;
    border-top-color: inherit;
}
.ribbon-flower-library span::before, .ribbon-special span::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid #f48062;
    border-right: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-top: 3px solid #f48062;
}
.ribbon span::after {
    content: "";
    position: absolute;
    right: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid transparent;
    border-right: 3px solid;
    border-right-color: inherit;
    border-bottom: 3px solid transparent;
    border-top: 3px solid;
    border-top-color: inherit;
}
.ribbon-flower-library span::after, .ribbon-special span::after {
    content: "";
    position: absolute;
    right: 0px;
    top: 100%;
    z-index: -1;
    border-left: 3px solid transparent;
    border-right: 3px solid #f48062;
    border-bottom: 3px solid transparent;
    border-top: 3px solid #f48062;
}
.ribbon2, .ribbon2-flower-library, .ribbon2-special {
    position: absolute;
    left: 1px;
    top: -1px;
    z-index: 150;
    overflow: hidden;
    width: 37px;
    height: 40px;
    text-align: right;
}

.ribbon2 span, .ribbon2-flower-library span, .ribbon2-special span {
    font-size: 6px;
    color: #FFF;
    text-transform: uppercase;
    text-align: center;
    line-height: 13px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    width: 40px;
    display: block;
    background: #f48062;
    background: linear-gradient(#f48062 0%, #f48062 100%);
    box-shadow: 0 3px 10px -5px rgb(0 0 0);
    position: absolute;
    top: 7px;
    right: 5px;
}
.ribbon2 span::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 100%;
    z-index: -1;
    border-left: 2px solid;
    border-left-color: inherit;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-top: 2px solid;
    border-top-color: inherit;
}
.ribbon2-flower-library span::before, .ribbon2-special span::before {
    content: "";
    position: absolute;
    left: 0px;
    top: 100%;
    z-index: -1;
    border-left: 2px solid #f48062;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    border-top: 2px solid #f48062;
}
.ribbon2 span::after {
    content: "";
    position: absolute;
    right: 0px;
    top: 100%;
    z-index: -1;
    border-left: 2px solid transparent;
    border-right: 2px solid;
    border-right-color: inherit;
    border-bottom: 2px solid transparent;
    border-top: 2px solid;
    border-top-color: inherit;
}
.ribbon2-flower-library span::after, .ribbon2-special span::after {
    content: "";
    position: absolute;
    right: 0px;
    top: 100%;
    z-index: -1;
    border-left: 2px solid transparent;
    border-right: 2px solid #f48062;
    border-bottom: 2px solid transparent;
    border-top: 2px solid #f48062;
}
</style>
<style>
.teleported-tooltip-trigger.product-ribbon-tooltip-card {
    position: absolute;
    top: -7px;
    left: -8px;
    z-index: 1;
    display: block;
    width: 86px;
    height: 76px;
}
.teleported-tooltip-trigger.product-ribbon-tooltip-card > .ribbon {
    top: 0;
    left: 0;
}
</style>